<template>
  <div class="row grupo-botones">
    <div
      v-if="Documento != null"
      class="grupo-botones__nombre col-9 d-flex justify-content-start"
      :style="desactivar === true ? 'background-color: #e5e5e5;' : ''"
    >
      <label v-if="NombreArchivo == null || NombreArchivo == ''">
        {{ ColocarTextoInput(esExtranjero) }}
      </label>
      <label v-else> {{ this.ReducirTexto }}</label>
    </div>
    <div
      v-else
      class="grupo-botones__nombre col-9 d-flex justify-content-start grupo-boton__deshabilitado"
    >
      <label> {{ ColocarTextoInput(esExtranjero) }} </label>
    </div>
    <div
      v-if="desactivar"
      class="grupo-botones__accion col-3 d-flex justify-content-center grupo-boton__deshabilitado"
    >
      <label> {{ ColocarTextoBoton(esExtranjero) }} </label>
    </div>
    <div
      v-else
      class="grupo-botones__accion col-3 d-flex justify-content-center"
    >
      <label
        v-if="NombreArchivo == null || NombreArchivo == ''"
        class="texto-escritorio"
      >
        {{ ColocarTextoBoton(esExtranjero) }}
      </label>
      <label v-else>
        <i class="fas fa-solid fa-check"></i>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputDocumentos",
  props: {
    Documento: {
      type: Number,
      default: null
    },
    NombreArchivo: String,
    ajusteMarginBoton: String,
    esExtranjero: {
      type: Boolean,
      default: false
    },
    desactivar: {
      type: Boolean
    }
  },
  computed: {
    ReducirTexto() {
      if (window.innerWidth <= 767 && this.NombreArchivo.length > 16) {
        return this.NombreArchivo.substring(0, 13).toLowerCase() + "...";
      } else {
        return this.NombreArchivo.toString().toLowerCase();
      }
    }
  },
  methods: {
    ColocarTextoInput(esExtranjero) {
      if (esExtranjero) {
        return "Choose a file";
      } else {
        return "Elige un archivo";
      }
    },
    ColocarTextoBoton(esExtranjero) {
      if (esExtranjero) {
        return "Upload";
      } else {
        return "Cargar";
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";

.grupo-botones {
  padding: 0px;
  font-weight: 400;
}
.grupo-botones__nombre {
  border: 1px solid black;
  font-size: 16px;
  cursor: pointer;
  align-items: center;
  height: 38px;
  max-height: 38px;
}
.grupo-botones__accion {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  background: $color-primario;
  color: white;
  font-size: 16px;
  cursor: pointer;
  height: 38px;
  max-height: 38px;
  align-items: center;
  cursor: pointer;
}
.grupo-boton__deshabilitado {
  opacity: 0.5;
  cursor: not-allowed;
}
.icono-movil-input {
  display: none;
}
@media all and (max-width: 767px) {
  .icono-movil-input {
    font-size: 24px;
    color: #ffffff;
    display: block;
  }
  .texto-escritorio {
    display: none;
  }
  .grupo-botones__accion {
    height: 45px;
    max-height: 45px;
  }
  .grupo-botones__nombre {
    height: 45px;
    max-height: 45px;
  }
}
</style>
